export default __webpack_public_path__ + "static/media/blog_1.acab371c.png";